import React from 'react';
import { useLocation, Link } from 'react-router-dom';
import classNames from 'classnames';
import { useI18n } from 'utils/I18n/context';
import ProfilePersonalInformationComponent from './ProfilePersonalInformation/ProfilePersonalInformation.container';
import SecurityPasswordComponent from './SecurityPassword/SecurityPassword.container';

const ProfilePage = () => {
    const { t } = useI18n();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const tab = queryParams.get('tab') || 'personalInfo';

    const getClassTabItem = (key) => classNames({ active: tab === key });
    const getClassTabPane = (key) => classNames('tab-pane', { active: tab === key });

    const staticNames = t.profilePage || {};
    const staticNameSecurity = t.securityPage || {};

    return (
        <React.Fragment>
            <div className="page-heading mobile-heading-fixed">
                <div className="page-heading__inner">
                    <h2>{staticNames.title || 'Profile'}</h2>
                </div>
            </div>

            <section className="wrapper-content user">
                <div className="ibox">
                    <div className="ibox-content">
                        <ul className="nav nav-tabs" id="profileTab">
                            <li className={getClassTabItem('personalInfo')}>
                                <Link to={`${location.pathname}?tab=personalInfo`}>
                                    {staticNames.personalInformation?.title || 'Personal Information'}
                                </Link>
                            </li>
                            <li className={getClassTabItem('security')}>
                                <Link to={`${location.pathname}?tab=security`}>
                                    {staticNameSecurity.changePassword?.title || 'Change Password'}
                                </Link>
                            </li>
                        </ul>
                        <div className="tab-content">
                            <div className={getClassTabPane('personalInfo')}>
                                <ProfilePersonalInformationComponent />
                            </div>
                            <div className={getClassTabPane('security')}>
                                <SecurityPasswordComponent />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
};

export default ProfilePage;